export const requestBody = `
{
  "id": ".....",
  "question": "上野公園にはどんな見所がありますか？",
  "answer": "はい、上野公園には多くの見どころがあります。学習した知識に基づいて、以下のような見所をご紹介できます：
1. 桜の名所：
上野公園は春の桜の名所として有名です。多くの桜の木が並び、春には美しい桜の花が咲き誇ります。花見客で賑わい、木の下で楽しくピクニックをする人々で溢れます。
2. 不忍池：
夏には不忍池に鮮やかなピンク色の蓮の花が咲きます。これは写真愛好家に人気のスポットです。
3. 上野動物園：
日本最古の動物園で、約300種3,000頭以上の動物が飼育されています。特に人気の高いパンダをはじめ、ゴリラ、トラ、アジアゾウ、ホッキョクグマなどを見ることができます。
4. 美術館・博物館：
上野公園には世界トップクラスの美術館や博物館が多数あります。国立西洋美術館、上野の森美術館、東京国立博物館、国立科学博物館などがあります。",
  "name": "東京観光",
  "discrible": "東京の観光ルート、有名スポット、食事、クルーズや船・ボートの楽しみ方、運河や川沿いのエリア紹介、宿泊先検索など、東京都全域のあらゆる観光情報をChatbotが提供しています。"
}
`;

export const responseBody = `
{
  "show_popup": true,
  "canvas_url": "https://example.com/test",
  "title": "上野公園の見どころ"
}
`;
